import { Component, Input } from '@angular/core';

import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

@Component({
	selector: 'app-validation-errors',
	templateUrl: 'validation-errors.component.html',
	styleUrls: ['validation-errors.component.scss']
})
export class ValidationErrorComponent {
	iconError = faExclamationCircle;

	@Input({ required: true })
	errors: string[];
}
